import { useState, useEffect } from 'react';

export const useTabsHook = (key, initialIndex) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(() => {
    const savedTabIndex = localStorage.getItem(key);
    const parsedIndex = savedTabIndex ? parseInt(savedTabIndex, 10) : null;
    return !isNaN(parsedIndex) ? parsedIndex : initialIndex;
  });

  useEffect(() => {
    localStorage.setItem(key, selectedTabIndex);
  }, [selectedTabIndex]);

  const handleTabChange = (id) => {
    setSelectedTabIndex(id);
    localStorage.setItem(key, id);
  };

  return { selectedTabIndex, handleTabChange };
};
